export enum TicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  WAITING = 'waiting',
  ESCALATED = 'escalated',
  CLOSED = 'closed',
  REOPENED = 'reopened',
}
